import { CommonSearchService } from '@savgroup-front-common/core/api';

import { getWorkflowsForBulkActionQuery } from '@/api/Search/bulkActions/getWorkflowsForBulkActionQuery';
import createBulkActionJobByFiltersCommand from '@/api/Search/createBulkActionJobByFiltersCommand';
import createBulkActionJobByIdsCommand from '@/api/Search/createBulkActionJobByIdsCommand';
import { createBulkActionJobFromConsoleCommand } from '@/api/Search/createBulkActionJobFromConsoleCommand';
import currentUserFiltersQuery from '@/api/Search/currentUserFiltersQuery';
import deleteFilterCommand from '@/api/Search/deleteFilterCommand';
import exportFilteredFilesCommand from '@/api/Search/exportFilteredFilesCommand';
import exportFilteredInterventionReportsCommand from '@/api/Search/exportFilteredInterventionReportsCommand';
import exportFilteredOrdersCommand from '@/api/Search/exportFilteredOrdersCommand';
import exportFilteredSparePartsRequestsCommand from '@/api/Search/exportFilteredSparePartsRequestsCommand';
import exportFilteredStockItemsCommand from '@/api/Search/exportFilteredStockItemsCommand';
import exportFilteredTodosCommand from '@/api/Search/exportFilteredTodosCommand';
import exportFilteredUsersCommand from '@/api/Search/exportFilteredUsersCommand';
import filterFilesCommand from '@/api/Search/filterFilesCommand';
import filterOrdersCommand from '@/api/Search/filterOrdersCommand';
import { filterTechniciansCommand } from '@/api/Search/filterTechniciansCommand';
import filterTodosCommand from '@/api/Search/filterTodosCommand';
import filterUsersCommand from '@/api/Search/filterUsersCommand';
import getBulkActionJobQuery from '@/api/Search/getBulkActionJobQuery';
import getBulkActionJobsQuery from '@/api/Search/getBulkActionJobsQuery';
import getExportedFileQuery from '@/api/Search/getExportedFileQuery';
import getExportJobQuery from '@/api/Search/getExportJobQuery';
import { getExportJobsByBulkActionJobIdQuery } from '@/api/Search/getExportJobsByBulkActionJobIdQuery';
import getFilesByQuery from '@/api/Search/getFilesByQuery';
import getFiltersFacets from '@/api/Search/getFiltersFacets';

export const SearchService = {
  deleteFilterCommand,
  getFilesByQuery,
  getFiltersFacets,
  currentUserFiltersQuery,
  upsertFilterCommand: CommonSearchService.upsertFilterCommand,
  filterFilesCommand,
  filterTechniciansCommand,
  filterTodosCommand,
  filterUsersCommand,
  exportFilteredFilesCommand,
  exportFilteredTodosCommand,
  exportFilteredOrdersCommand,
  exportFilteredUsersCommand,
  getExportJobQuery,
  getExportedFileQuery,
  filterOrdersCommand,
  exportFilteredSparePartsRequestsCommand,
  exportFilteredStockItemsCommand,
  exportFilteredInterventionReportsCommand,
  createBulkActionJobByFiltersCommand,
  createBulkActionJobByIdsCommand,
  getBulkActionJobQuery,
  getBulkActionJobsQuery,
  getWorkflowsForBulkActionQuery,
  getExportJobsByBulkActionJobIdQuery,
  createBulkActionJobFromConsoleCommand,
};
